export default __webpack_public_path__ + "static/media/enviro_logo.efdbbd9a.png";